import {
  useCreateImvFollowUpDataMutation,
  useLazyGetAllImvFollowUpDataQuery,
  useLazyGetPublishImvFollowUpDataQuery,
  useLazyGetimvFollowUpLetterQuery,
  usePublishImvFollowUpDataMutation,
  useUpdateImvFollowUpDataMutation
} from 'src/services/IMVFollowUpLetter';

export const useIMVFollowUpVisit = () => {
  const [
    getAllimvFollowUpData,
    {
      data: allImvFollowData,
      error: allImvFollowDataError,
      isError: allImvFollowDataIsError,
      isLoading: allImvFollowDataIsLoading,
      isSuccess: allImvFollowDataIsSuccess
    }
  ] = useLazyGetAllImvFollowUpDataQuery();

  const [
    getPublishimvFollowUpData,
    {
      data: allPublishImvFollowData,
      error: allPublishImvFollowDataError,
      isError: allPublishImvFollowDataIsError,
      isLoading: allPublishImvFollowDataIsLoading,
      isSuccess: allPublishImvFollowDataIsSuccess
    }
  ] = useLazyGetPublishImvFollowUpDataQuery();
  const [
    getimvFollowUpData,
    {
      data: imvFollowData,
      error: imvFollowDataError,
      isError: imvFollowDataIsError,
      isLoading: imvFollowDataIsLoading,
      isSuccess: imvFollowDataIsSuccess
    }
  ] = useLazyGetimvFollowUpLetterQuery();
  const [
    createImvFollowUp,
    {
      data: createImvFollowUpData,
      error: createImvFollowUpError,
      isError: createImvFollowUpIsError,
      isLoading: createImvFollowUpIsLoading,
      isSuccess: createImvFollowUpIsSuccess
    }
  ] = useCreateImvFollowUpDataMutation();
  const [
    updateImvFollowUp,
    {
      data: updateImvFollowData,
      error: updateImvFollowUpError,
      isError: updateImvFollowUpIsError,
      isLoading: updateImvFollowUpIsLoading,
      isSuccess: updateImvFollowUpIsSuccess
    }
  ] = useUpdateImvFollowUpDataMutation();
  const [
    publishImvFollowUpData,
    {
      data: publishImvFollowUp,
      error: publishImvFollowUpError,
      isError: publishImvFollowUpIsError,
      isLoading: publishImvFollowUpIsLoading,
      isSuccess: publishImvFollowUpIsSuccess
    }
  ] = usePublishImvFollowUpDataMutation();

  return {
    allImvFollowData,
    allImvFollowDataError,
    allImvFollowDataIsError,
    allImvFollowDataIsLoading,
    allImvFollowDataIsSuccess,
    getAllimvFollowUpData,
    imvFollowData,
    imvFollowDataError,
    imvFollowDataIsError,
    imvFollowDataIsLoading,
    imvFollowDataIsSuccess,
    getimvFollowUpData,
    createImvFollowUpData,
    createImvFollowUpError,
    createImvFollowUpIsError,
    createImvFollowUpIsLoading,
    createImvFollowUpIsSuccess,
    createImvFollowUp,
    updateImvFollowData,
    updateImvFollowUpError,
    updateImvFollowUpIsError,
    updateImvFollowUpIsLoading,
    updateImvFollowUpIsSuccess,
    updateImvFollowUp,
    publishImvFollowUp,
    publishImvFollowUpError,
    publishImvFollowUpIsError,
    publishImvFollowUpIsLoading,
    publishImvFollowUpIsSuccess,
    publishImvFollowUpData,
    allPublishImvFollowData,
    allPublishImvFollowDataError,
    allPublishImvFollowDataIsError,
    allPublishImvFollowDataIsLoading,
    allPublishImvFollowDataIsSuccess,
    getPublishimvFollowUpData
  };
};
